<script lang="ts" setup>
import FloatLabel from 'primevue/floatlabel'
import InputText from 'primevue/inputtext'
import Message from 'primevue/message'
import Password from 'primevue/password'

const props = defineProps<{
  modelValue?: any
  name: string
  type: string
  label?: string
  placeholder?: string
  disabled?: boolean
  maxLength?: number
  fieldClass?: string
  min?: number
  max?: number
  step?: number
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

</script>

<template>
  <FormField
    v-slot="$field"
    :class="'flex flex-col gap-1 ' + (props.fieldClass || '')"
    :name="props.name"
  >
    <FloatLabel variant="on">
      <!-- Password Input -->
      <template v-if="props.type === 'password'">
        <Password
          :disabled="props.disabled"
          :feedback="false"
          :input-id="props.name"
          :name="props.name"
          class="w-full"
          toggle-mask
        />
      </template>
      <!-- Default Input -->
      <template v-if="props.type === 'text' || props.type === 'email'">
        <InputText
          :id="props.name"
          :model-value="props.modelValue"
          :disabled="props.disabled"
          :maxlength="props.maxLength"
          :name="props.name"
          :placeholder="props.placeholder || ''"
          :type="props.type"
          class="w-full"
          @update:model-value="emit('update:modelValue', $event)"
        />
      </template>
      <template v-else-if="props.type === 'number'">
        <InputNumber
          :id="props.name"
          locale="it-IT"
          :model-value="props.modelValue"
          :disabled="props.disabled"
          :maxlength="props.maxLength"
          :name="props.name"
          :placeholder="props.placeholder || ''"
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          class="w-full"
          :min="props.min"
          :max="props.max"
          :max-fraction-digits="2"
          :step="props.step"
          @update:model-value="emit('update:modelValue', $event)"
        />
      </template>

      <label v-if="props.label != null" :for="props.name">{{ props.label }}</label>
    </FloatLabel>

    <Message v-if="$field?.invalid" severity="error" size="small">
      {{ $field.error?.message }}
    </Message>
  </FormField>
</template>

<style lang="scss" scoped>
:deep(.p-calendar) {
  width: 100%;

  .p-inputtext {
    width: 100%;
  }
}
</style>
